import type { Ref } from 'vue';
import { computed } from 'vue';

import { useTokensQuery } from '@modules/tokens/queries';

export interface IUserSupervisionComposable {
  isSupervision: Ref<boolean>;
}

export default function useUserSupervision(): IUserSupervisionComposable {
  const { data } = useTokensQuery();

  const isSupervision = computed<boolean>(() => !!data.value?.supervision);

  return {
    isSupervision,
  };
}
